import { Action } from '@ngrx/store';
import { CustomerSettings } from '../../shared/models/customer-settings.model';
import { DocumentWithId, DocumentWithRev } from '../../../../shared/services/db/models/document-with-type';

export const SAVE_CUSTOMER_SETTINGS = '[XENA] SAVE_CUSTOMER_SETTING';
export const SAVE_CUSTOMER_SETTINGS_SUCCESS = '[XENA] SAVE_CUSTOMER_SETTING_SUCCESS';
export const SAVE_CUSTOMER_SETTINGS_ERROR = '[XENA] SAVE_CUSTOMER_SETTING_ERROR';

export const LOAD_CUSTOMER_SETTINGS = '[XENA] LOAD_CUSTOMER_SETTING';
export const LOAD_CUSTOMER_SETTINGS_SUCCESS = '[XENA] LOAD_CUSTOMER_SETTING_SUCCESS';
export const LOAD_CUSTOMER_SETTINGS_ERROR = '[XENA] LOAD_CUSTOMER_SETTING_ERROR';

export const DELETE_CUSTOMER_SETTINGS = '[XENA] DELETE_CUSTOMER_SETTINGS';
export const DELETE_CUSTOMER_SETTINGS_SUCCESS = '[XENA] DELETE_CUSTOMER_SETTINGS_SUCCESS';
export const DELETE_CUSTOMER_SETTINGS_ERROR = '[XENA] DELETE_CUSTOMER_SETTINGS_ERROR';


export class SaveCustomerSettings implements Action {
	readonly type = SAVE_CUSTOMER_SETTINGS;

	constructor(public payload: CustomerSettings) {}
}

export class SaveCustomerSettingsSuccess implements Action {
	readonly type = SAVE_CUSTOMER_SETTINGS_SUCCESS;

	constructor(public payload: CustomerSettings) {}
}

export class SaveCustomerSettingsError implements Action {
	readonly type = SAVE_CUSTOMER_SETTINGS_ERROR;
}

export class LoadCustomerSettings implements Action {
	readonly type = LOAD_CUSTOMER_SETTINGS;
}

export class LoadCustomerSettingsSuccess implements Action {
	readonly type = LOAD_CUSTOMER_SETTINGS_SUCCESS;

	constructor(public payload: CustomerSettings[]) {}
}

export class LoadCustomerSettingsError implements Action {
	readonly type = LOAD_CUSTOMER_SETTINGS_ERROR;
}

export class DeleteCustomerSettings implements Action {
	readonly type = DELETE_CUSTOMER_SETTINGS;

	constructor(public payload) {};
}

export class DeleteCustomerSettingsSuccess implements Action {
	readonly type = DELETE_CUSTOMER_SETTINGS_SUCCESS;

	constructor(public payload: (DocumentWithId & DocumentWithRev)) {};
}

export class DeleteCustomerSettingsError implements Action {
	readonly type = DELETE_CUSTOMER_SETTINGS_ERROR;
}

export type All
	= SaveCustomerSettings
	| SaveCustomerSettingsSuccess
	| SaveCustomerSettingsError
	| LoadCustomerSettings
	| LoadCustomerSettingsSuccess
	| LoadCustomerSettingsError
	| DeleteCustomerSettings
	| DeleteCustomerSettingsSuccess
	| DeleteCustomerSettingsError;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/actions/customer-settings.ts